import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

export const Container = styled.div`
    position: relative;
    border-radius: 7px;
    flex: 1;
    z-index: 99;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 135px;
    max-height: 46px;
`

export const Progress = styled.canvas`
  position: absolute;
  height: 105%;
  width: 135px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: 105%;
    width: 100%;
  }
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

 
  padding: 10px;
`

export const Clock = styled.img`
  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: 22px;
  }
`

export const Time = styled.p`
  margin: 0;
  margin-left: 15px;

  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  width: 45px;
  text-shadow: #444 1px 1px 5px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
      font-size: 16px;
  }
`
